// Turns the backend's INELIGIBLE credit_status_reason (written for ops, see alertprocess.class.inc)
// into a merchant-facing explanation. Unknown reasons fall back to the generic message rather than
// showing the raw ops text.
const REASONS = [
    {
        // Also matches the duplicate-alert variant "Original alert actioned outside credit eligible period (Nhrs)".
        pattern: /credit eligible period \((\d+)\s*hrs\)/i,
        message: (t, match) =>
            t("contents.alerts.credit_ineligible_period", { hours: match[1] }) ||
            `This alert is not eligible for credit because the ${match[1]}-hour eligibility period has expired. Uploading documents will not change its eligibility.`,
    },
    {
        pattern: /^refund not allowed for site/i,
        message: (t) =>
            t("contents.alerts.credit_ineligible_site") ||
            "This alert is not eligible for credit because refunds are not enabled for this site. Uploading documents will not change its eligibility.",
    },
    {
        pattern: /^Original alert actioned with reason code 902/i,
        message: (t) =>
            t("contents.alerts.credit_ineligible_non_billable") ||
            "This alert is not eligible for credit because the original alert was actioned as non-billable. Uploading documents will not change its eligibility.",
    },
    {
        pattern: /^Original alert not refunded/i,
        message: (t) =>
            t("contents.alerts.credit_ineligible_not_refunded") ||
            "This alert is not eligible for credit because the original alert was not refunded. Uploading documents will not change its eligibility.",
    },
    {
        pattern: /^Cross provider duplicate alert/i,
        message: (t) =>
            t("contents.alerts.credit_ineligible_cross_provider") ||
            "This alert is not eligible for credit because it duplicates an alert from another provider. Uploading documents will not change its eligibility.",
    },
];

export const isIneligibleCredit = (credit) => (credit?.credit_status || "").toUpperCase() === "INELIGIBLE";

export const creditIneligibleMessage = (t, reason) => {
    const text = (reason || "").trim();
    for (const { pattern, message } of REASONS) {
        const match = text.match(pattern);
        if (match) return message(t, match);
    }
    return (
        t("contents.alerts.credit_ineligible") ||
        "This alert is not eligible for credit. Uploading documents will not change its eligibility."
    );
};
